import React from 'react';
import classNames from 'classnames';
import { offRampStatus } from 'offRamp/propTypes';
import styles from './index.module.css';

const statuses = {
  pending: 'Pending',
  completed: 'Completed',
  expired: 'Expired',
  cancelled: 'Canceled',
};

const Status = ({ value }) => {
  const className = classNames(styles.status, styles[value]);

  return <div className={className}>{statuses[value]}</div>;
};

Status.propTypes = {
  value: offRampStatus.isRequired,
};

export default Status;
